"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = createRecord;
/**
 * Turns an array of objects into a map based on the key.
 * All keys must be unique.
 * @param items List of objects
 * @param key The property name of the unique identifier on each of the objects
 * @returns Record of objects
 */
function createRecord(items, key) {
    return items.reduce((prev, cur) => {
        const keyValue = cur[key];
        if (typeof keyValue !== 'string' && typeof keyValue !== 'number') {
            throw `value of ${key} is not a string or a number`;
        }
        if (prev[keyValue]) {
            throw `value ${keyValue} for ${key} is not unique`;
        }
        prev[keyValue] = cur;
        return prev;
    }, {});
}
//# sourceMappingURL=createRecord.js.map